module.exports = require("crypto");


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 2
// module chunks = 0